import React from "react";
import { useTranslation } from "react-i18next";
import CampaignTable from "./CampaignTable";
import PageHead from "../../../Common/PageHead";
import { CampaignRow } from "../data";

interface CampaignListProps {
  /** Keys of the campaigns deleted in this session, which the table hides. */
  deleted: string[];
  onCreate: () => void;
  onOpen: (row: CampaignRow, mode: "preview" | "edit" | "copy") => void;
}

export default function CampaignList({
  deleted,
  onCreate,
  onOpen,
}: CampaignListProps) {
  const { t } = useTranslation();

  // Layout gives every direct child of the content area a white card and 16px
  // below it, and renders the page heading the same way. These are siblings so
  // they get that treatment individually — wrapping them would put the heading
  // inside the card. `transparent` opts the heading row out of the card, the
  // way Layout's own title row does.
  return (
    <>
      <PageHead title={t("routes.campaigns")} />

      <CampaignTable deleted={deleted} onCreate={onCreate} onOpen={onOpen} />
    </>
  );
}
